import TigerWorksLanding from './TigerWorksLanding';

function App() {
  return <TigerWorksLanding />;
}

export default App;
